import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './utils/setRem';
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts; //注册echarts
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import Vant from 'vant';
import 'vant/lib/index.css';
import VueMeta from 'vue-meta';
// import './utils/setRem'; // 放在最前面
Vue.use(VueMeta);
Vue.use(Vant);

Vue.config.productionTip = false;
import watermark from './utils/watermark.js';
Vue.prototype.$watermark = watermark;

// 自动引入并全局注册组件（包括多级目录下的组件）
const files = require.context('./components', true, /\.vue$/);
files.keys().forEach((key) => {
  if (key != './my_page/gz.vue') {
    //./my_page/gz.vue这个页面用了禁止橡皮筋功能  自动引入这个页面会导致全部页面无法滚动  所以排除此页面
    const component = files(key).default;
    const componentName =
      component.name ||
      key
        .split('/')
        .pop()
        .replace(/\.\w+$/, '');
    Vue.component(componentName, component);
  }
});

(function () {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = window.config.scLink;
  document.body.appendChild(script);
})();

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
